<template>
    <transition name="slide-in" appear>
        <section class="gz-authorization-container">
            <section>
                <GZ-PageSubtitle title="Вход"/>
                
                <gz-input-container 
                    label="Email"
                    class="mbottom-20px"
                    :valid="email.valid"
                    :validationMessage="email.validationMessage"
                    :required="true"  
                    icon="icon-mobile-alt-solid"
                >
                    <GZ-TextInput
                        class="gz-text-input_dark"
                        @value="email.value = $event"
                    />
                </gz-input-container>
                
                <gz-input-container 
                    label="Пароль"
                    class="mbottom-20px"
                    :valid="password.valid"
                    :validationMessage="password.validationMessage"
                    :required="true"
                    :loading="loading"  
                    icon="icon-key"
                >
                    <GZ-TextInput
                        type="password"
                        class="gz-text-input_dark"
                        @value="password.value = $event"
                    />
                </gz-input-container>

                <section class="gz-controls-section gz-controls-section_login">
                    <GZ-BaseButton 
                        value="войти" 
                        class="gz-button gz-button_default gz-button_login gz-button_accent"
                        @click="login"
                    />
                    <!-- <GZ-BaseButton 
                        value="забыли пароль?" 
                        class="gz-button gz-button_monohrome"
                    /> -->
                </section> <!-- gz-controls-section -->
            </section>
        </section> <!-- gz-authorization-container-->
    </transition>
</template>

<script>
export default {
    name: 'BaseAuthorization',

    data() {
        return {
            phone: {
                value: '',
                valid: true,
                validationMessage: ''
            },
            email: {
                value: '',
                valid: true,
                validationMessage: ''
            },
            password: {
                value: '',
                valid: true,
                validationMessage: ''
            },
            loading: false
        }
    },
    methods: {
        validation() {
            const message = this.$store.getters['validationMessages']

            let errors = 0

             //** Email */
            //не пустое
            if (!this.isEmpty(this.email.value)) {
                this.formValidationUtil(this.email, false, message.isEmtpy)
                errors++
            } else {
                this.formValidationUtil(this.email, true, '')
                //Syntax
                if (!this.emailValidation(this.email.value)) {
                    this.formValidationUtil(this.email, false, message.uncorrectEmail)
                    errors++
                } else {
                    this.formValidationUtil(this.email, true, '')
                }
            }

             //** Пароль */
            //не пустое
            if (!this.isEmpty(this.password.value)) {
                this.formValidationUtil(this.password, false, message.isEmtpy)
                errors++
            } else {
                this.formValidationUtil(this.password, true, '')
            }

            //Notification
            return this.validationNotification(errors)
        },
        login() {
            if (this.validation()) {
                this.$store.dispatch('login', {
                    email: this.email.value,
                    password: this.password.value
                })
            }
        }
    }
}
</script>